import { func, oneOf, string, bool } from "prop-types";

/*
    If you change the structure in this file, you must check:
        Drawer.js and ExampleButton.js

    (This will not break any component that is using
        Drawer if you just add keys)
*/

/* Drawer PropType */

export const DrawerPropType = {
    className: string,
    type: oneOf(["bottom", "right"]),
    onClose: func,
    enableCloseButton: bool,
    notCreateInRoot: bool,
};

export const defaultDrawerPropType = {
    type: "auto",
    className: "",
    onClose: null,
    enableCloseButton: true,
    notCreateInRoot: false,
};
